/* Amyan Art draft overrides (10/2026). Loaded sitewide, deferred, from the custom-liquid section in sections/footer-group.json. */
(function () {
  var ARROW_PATHS = { prev: 'M15 6l-6 6 6 6', next: 'M9 6l6 6-6 6' };

  function arrowSvg(dir, size) {
    return '<svg viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + ARROW_PATHS[dir] + '"></path></svg>';
  }

  // One arrow click moves a scrolling row by as many whole cards as fit in view.
  function pageWidth(row, itemSelector) {
    var item = row.querySelector(itemSelector);
    if (!item) return row.clientWidth;
    var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
    var card = item.getBoundingClientRect().width + gap;
    if (!card) return row.clientWidth;
    return card * Math.max(1, Math.floor(row.clientWidth / card));
  }

  // Home Flash Sale row: wrap the scrolling row and add previous / next arrow buttons.
  // Styles are in assets/amyan-overrides-b.css.
  function initFlashSaleArrows() {
    var row = document.getElementById('amyanFsRow');
    if (!row || row.dataset.amyanArrows) return;
    row.dataset.amyanArrows = '1';

    var holder = document.createElement('div');
    holder.className = 'amyan-fs__carousel';
    row.parentNode.insertBefore(holder, row);
    holder.appendChild(row);

    function makeArrow(dir, label) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'amyan-fs__arrow amyan-fs__arrow--' + dir;
      btn.setAttribute('aria-label', label);
      btn.innerHTML = arrowSvg(dir, 18);
      holder.appendChild(btn);
      return btn;
    }

    var prev = makeArrow('prev', 'Previous flash sale products');
    var next = makeArrow('next', 'More flash sale products');

    function update() {
      var max = row.scrollWidth - row.clientWidth - 1;
      prev.disabled = row.scrollLeft <= 0;
      next.disabled = row.scrollLeft >= max;
      holder.classList.toggle('amyan-fs__carousel--static', row.scrollWidth <= row.clientWidth + 1);
    }

    prev.addEventListener('click', function () {
      row.scrollBy({ left: -pageWidth(row, '.amyan-fs__item'), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      row.scrollBy({ left: pageWidth(row, '.amyan-fs__item'), behavior: 'smooth' });
    });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    // Images can change the row width after load.
    window.addEventListener('load', update);
  }

  // Cart drawer "You may also like": previous / next arrow buttons. Styles are in
  // assets/amyan-overrides-c.css. The theme re-renders the drawer whenever the cart
  // changes, which can remove the buttons, so they are re-added whenever they are missing.
  function updateUpsellArrows(box) {
    var list = box.querySelector('.amyan-cart-upsell__list');
    if (!list) return;
    var max = list.scrollWidth - list.clientWidth - 1;
    var prev = box.querySelector('.amyan-upsell__arrow--prev');
    var next = box.querySelector('.amyan-upsell__arrow--next');
    if (prev) prev.disabled = list.scrollLeft <= 0;
    if (next) next.disabled = list.scrollLeft >= max;
  }

  function ensureUpsellArrows() {
    document.querySelectorAll('.amyan-cart-upsell').forEach(function (box) {
      var list = box.querySelector('.amyan-cart-upsell__list');
      if (!list) return;
      if (!box.querySelector('.amyan-upsell__arrow')) {
        ['prev', 'next'].forEach(function (dir) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'amyan-upsell__arrow amyan-upsell__arrow--' + dir;
          btn.setAttribute('data-amyan-upsell-arrow', dir);
          btn.setAttribute('aria-label', dir === 'prev' ? 'Previous suggestions' : 'More suggestions');
          btn.innerHTML = arrowSvg(dir, 14);
          box.appendChild(btn);
        });
      }
      if (!list.__amyanArrowScroll) {
        list.__amyanArrowScroll = true;
        list.addEventListener('scroll', function () { updateUpsellArrows(box); }, { passive: true });
      }
      updateUpsellArrows(box);
    });
  }

  var upsellArrowsQueued = false;
  function queueUpsellArrows() {
    if (upsellArrowsQueued) return;
    upsellArrowsQueued = true;
    window.requestAnimationFrame(function () {
      upsellArrowsQueued = false;
      ensureUpsellArrows();
    });
  }

  function init() {
    initFlashSaleArrows();
    ensureUpsellArrows();
    new MutationObserver(queueUpsellArrows).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', queueUpsellArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cart drawer "You may also like": make the Add button, image tap and name link work
  // when the page was loaded with an EMPTY cart.
  //
  // The original handler is an inline script that sits inside the upsell block. That block
  // is only rendered when the cart has items. If a visitor arrives with an empty cart and
  // then adds a product, the theme inserts the block into the open drawer, but a browser
  // never runs a script that is inserted that way, so nothing was listening for the tap.
  // The original script sets window.__amyanCartUpsellInit when it does run (page loaded
  // with items already in the cart); in that case this fallback stays out of the way so a
  // tap never adds the product twice.
  function upsellOriginalIsActive() {
    return window.__amyanCartUpsellInit === true;
  }

  function upsellAdvanceImage(el) {
    var urls = (el.getAttribute('data-images') || '').split('|').filter(function (u) { return u; });
    if (urls.length <= 1) return;
    var idx = parseInt(el.getAttribute('data-img-index'), 10);
    if (isNaN(idx)) idx = 0;
    idx = (idx + 1) % urls.length;
    el.setAttribute('data-img-index', String(idx));
    var img = el.querySelector('img');
    if (img) img.src = urls[idx];
  }

  // Same flow as the original: tell the theme a cart update is starting, add the item,
  // then hand the theme the fresh cart so the drawer re-renders itself.
  function upsellAddToCart(variantId, button) {
    if (!variantId || button.disabled) return;
    button.disabled = true;

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    function postAdd() {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, sections: sectionIds.join(',') })
      }).then(function (res) { return res.json(); }).then(function (addResponse) {
        if (addResponse.status) throw new Error(addResponse.message || 'Add to cart failed');
        return addResponse;
      });
    }

    import('@shopify/events').then(function (mod) {
      var CartLinesUpdateEvent = mod.CartLinesUpdateEvent;
      var deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferred.promise
      }));
      return postAdd().then(function (addResponse) {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (ajaxCart) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
              detail: {
                items: ajaxCart.items,
                source: 'amyan-cart-upsell',
                itemCount: 1,
                sections: addResponse.sections,
                didError: false
              }
            });
          });
      }).catch(function (err) {
        deferred.reject(err);
        throw err;
      });
    }, function () {
      // The theme's event module could not be loaded: add the item anyway and reload so the cart shows it.
      return postAdd().then(function () { window.location.reload(); });
    }).catch(function (err) {
      console.error('[amyan-cart-upsell fallback] add to cart failed', err);
    }).then(function () {
      button.disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    // Arrow buttons are always handled here; the original script knows nothing about them.
    var arrow = target.closest('[data-amyan-upsell-arrow]');
    if (arrow) {
      e.preventDefault();
      var box = arrow.closest('.amyan-cart-upsell');
      var list = box && box.querySelector('.amyan-cart-upsell__list');
      if (list) {
        var dir = arrow.getAttribute('data-amyan-upsell-arrow') === 'prev' ? -1 : 1;
        list.scrollBy({ left: dir * pageWidth(list, '.amyan-cart-upsell__item'), behavior: 'smooth' });
      }
      return;
    }

    if (upsellOriginalIsActive()) return;

    var imageWrap = target.closest('[data-amyan-upsell-image]');
    if (imageWrap) {
      e.preventDefault();
      upsellAdvanceImage(imageWrap);
      return;
    }
    var link = target.closest('[data-amyan-upsell-link]');
    if (link) {
      window.location.href = link.getAttribute('data-amyan-upsell-link');
      return;
    }
    var btn = target.closest('[data-amyan-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    upsellAddToCart(btn.dataset.variantId, btn);
  });

  document.addEventListener('keydown', function (e) {
    if (upsellOriginalIsActive()) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var target = e.target;
    if (!target || !target.closest) return;

    var imageWrap = target.closest('[data-amyan-upsell-image]');
    if (imageWrap) {
      e.preventDefault();
      upsellAdvanceImage(imageWrap);
      return;
    }
    var link = target.closest('[data-amyan-upsell-link]');
    if (link) {
      e.preventDefault();
      window.location.href = link.getAttribute('data-amyan-upsell-link');
    }
  });
})();
